/*
 *@Description: 预取号下单
*/
<template>
  <div class="main-wrap batch-order">
    <div class="progress-box" v-if="bulkOrdering">
      <div class="progress-container">
        <div class="progress-wrap">
          <div class="progress" :style="{ width: progress + '%' }"></div>
        </div>
        <div class="num">{{ $lang('正在下单') }}{{ progress }}%</div>
      </div>
    </div>
    <div class="search-group">
      <div class="search">
        <div class="buttons">
          <el-button icon="iconfont icondaoru" type="primary" class="h40 importOrder" :disabled="keyBtn" @click="importOrder">{{ $lang('批量导入') }}</el-button>
          <el-button icon="iconfont iconxiazai" type="primary" class="h40" plain :disabled="keyBtn" @click="OrderTemplate = 1">{{ $lang('下载模板') }}</el-button>
          <el-button icon="iconfont iconbianji" type="primary" class="h40" plain @click="batcheditOrder" :disabled="keyBtn || multipleSelection.length < 1 ? true : false">{{
              $lang('批量设置')
            }}
          </el-button>
          <el-button icon="iconfont iconshanchu" type="primary" class="h40" plain @click="deleteOrder" :disabled="keyBtn || multipleSelection.length < 1 ? true : false">{{
              $lang('删除')
            }}
          </el-button>
        </div>
        <div>
          <label style="line-height: 32px; color: #666">{{ $lang('寄件人') }}：</label>
          <el-input :placeholder="$lang('请选择寄件人信息')" readonly :value="userSender" style="width: 512px !important">
            <template slot="suffix">
              <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
            </template>
          </el-input>
          <el-tooltip effect="dark" placement="bottom">
            <span class="tooltip-click">?</span>
            <div slot="content">{{ $lang('若导入模板为“无寄件人”模板，则默认使用该寄件人信息') }}<br/></div>
          </el-tooltip>
        </div>
      </div>
      <el-button type="primary" @click="setOrder" :loading="keyBtn" :disabled="keyBtn || multipleSelection.length < 1 ? true : false" class="setOrder h48">{{
          keyBtn ? $lang('下单中...') : $lang('立即下单')
        }}
      </el-button>
    </div>

    <el-alert type="success" center v-if="showBulkResult" @close="closeAlert">
      <div v-if="errorLength === 0">
        {{ $lang('本次共提交') }}{{ allLength }}{{ $lang('条订单') }}，{{ successLength }}{{ $lang('条成功') }}，{{ errorLength }}{{ $lang('条提交失败') }}。
      </div>
      <div v-else>
        {{ $lang('本次共提交') }}{{ allLength }}{{ $lang('条订单') }}，{{ successLength }}{{ $lang('条成功') }}，{{ errorLength }}{{ $lang('条失败，请重新提交失败的订单') }}。
      </div>
    </el-alert>
    <el-alert type="success" center v-if="showImportResult" @close="closeAlert">
      <div>{{ $lang('本次共导入') }}{{ leadAllLength }}{{ $lang('条数据') }}，{{ leadSuccessLength }}{{ $lang('条成功') }}，{{ leadErrorLength }}{{ $lang('条失败') }}。</div>
    </el-alert>
    <div class="list">
      <div class="tabs">
        <div :class="{ active: tabActive === 0 }" @click="changeTab(0)"><i class="iconfont iconchenggong"></i>{{ $lang('导入成功') }}</div>
        <div :class="{ active: tabActive === 1 }" @click="changeTab(1)" style="margin-left: 10px"><i class="iconfont iconshibai"></i>{{ $lang('导入失败') }}</div>
      </div>
      <el-table
        ref="multipleTable"
        :data="list"
        border
        style="width: 100%; border-top: 0"
        :max-height="tableHeight - 165"
        :height="tableHeight - 165"
        v-el-table-infinite-scroll="load"
        @select-all="handleSelectAll"
        @select="handleSelectionChange"
        @row-click="rowEdit"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column :label="$lang('序号')" prop="formIndex"></el-table-column>
        <el-table-column prop="errorMsg" width="150" :label="$lang('错误原因')" v-if="showErr" :show-overflow-tooltip="true">
          <template slot-scope="{ row }">
            <div class="errorTip">{{ row.errorMsg }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="thirdPartyWaybillId" :label="$lang('三方运单号')" width="100">
          <template slot-scope="{ row }">
            <div>{{ row.thirdPartyWaybillId || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="customerOrderId" :label="$lang('客户订单号')" width="100">
          <template slot-scope="{ row }">
            <div>{{ row.customerOrderId || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverName" :label="$lang('收件人姓名')" width="90">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.receiverName}">{{ row.receiverName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverMobilePhone" :label="$lang('收件人电话')" width="110">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.receiverMobilePhone}">{{ row.receiverMobilePhone || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverTelphone" :label="$lang('收件人电话') + '2'" width="110">
          <template slot-scope="{ row }">
            <div>{{ row.receiverTelphone || '--' }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="receiverRoomNumber" :label="$lang('收件房号')">
          <template slot-scope="{ row }">
            <div>{{ row.receiverRoomNumber || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverFloor" :label="$lang('收件楼层')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.receiverFloor || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverBuildingNo" :label="$lang('收件楼号')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.receiverBuildingNo || '--' }}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="receiverStreet" :label="$lang('收件街道')" min-width="90" :show-overflow-tooltip="true">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.receiverStreet}">{{ row.receiverStreet || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverAreaName" :label="$lang('收件地区')" width="100">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.receiverAreaName}">{{ row.receiverAreaName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverCityName" :label="$lang('收件城市')" width="90">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.receiverCityName}">{{ row.receiverCityName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverProvinceName" :label="$lang('收件省')" width="90">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.receiverProvinceName}">{{ row.receiverProvinceName || '--' }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="receiverRemark" :label="$lang('派件备注')" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.receiverRemark || '--' }}</div>
          </template>
        </el-table-column> -->

        <el-table-column prop="senderName" :label="$lang('寄件人姓名')" width="90" v-if="containSender">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.senderName}">{{ row.senderName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderMobilePhone" :label="$lang('寄件人电话')" width="100" v-if="containSender">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.senderMobilePhone}">{{ row.senderMobilePhone || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderTelphone" :label="$lang('寄件人电话') + '2'" width="100" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.senderTelphone || '--' }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="sendRoomNumber" :label="$lang('寄件房号')" min-width="80" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.sendRoomNumber || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sendFloor" :label="$lang('寄件楼层')" min-width="80" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.sendFloor || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sendBuildingNo" :label="$lang('寄件楼号')" min-width="80" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.sendBuildingNo || '--' }}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="senderStreet" :label="$lang('寄件街道')" width="80" v-if="containSender">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.senderStreet}">{{ row.senderStreet || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderAreaName" :label="$lang('寄件地区')" width="80" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.senderAreaName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderCityName" :label="$lang('寄件城市')" width="80" v-if="containSender">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.senderCityName}">{{ row.senderCityName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderProvinceName" :label="$lang('寄件省')" width="90" v-if="containSender">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.senderProvinceName}">{{ row.senderProvinceName || '--' }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="sendRemark" :label="$lang('寄件备注')" min-width="80" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.sendRemark || '--' }}</div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="senderDetailedAddress" :label="$lang('寄件详细地址')" width="200" v-if="containSender">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.senderDetailedAddress}">{{ row.senderDetailedAddress || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderEmail" :label="$lang('寄件人邮箱')" width="110"  v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.senderEmail || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderCompany" :label="$lang('寄件公司名称')" width="120" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.senderCompany || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="senderPostalCode" :label="$lang('寄件人邮编')" width="100" v-if="containSender">
          <template slot-scope="{ row }">
            <div>{{ row.senderPostalCode || '--' }}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="goodsTypeName" :label="$lang('物品类型')" min-width="80">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.goodsTypeName}">{{ row.goodsTypeName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" :label="$lang('物品名称')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.goodsName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="packageTotalWeight" :label="$lang('物品重量')" min-width="80">
          <template slot-scope="{ row }">
            <!-- 重量默认展示1 -->
            <div :class="{'errorData': !row.packageTotalWeight}">{{ row.packageTotalWeight || '1kg' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="customerPickNumber" :label="$lang('客户拣货数量')" :show-overflow-tooltip="true" width="100">
          <template slot-scope="{ row }">
            <div>{{ row.customerPickNumber || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="insured" :label="$lang('是否保价')" min-width="80">
          <template slot-scope="{ row }">
            <div :class="{'errorData': (!row.insured && !row.insured === 0)}">{{ row.insured === 1 ? $lang('是') : $lang('否') }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="declaredValue" :label="$lang('保险价值')" min-width="80">
          <template slot-scope="{ row }">
            <div :class="{'errorData': (row.insured === 1 && !row.declaredValue)}">{{ row.declaredValue || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="insuredValue" :label="$lang('保价费')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.insuredValue || '--' }}</div>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="packageNumber" :label="$lang('包裹数量')" min-width="100"> </el-table-column> -->
        <!-- <el-table-column prop="packageLength" :label="$lang('长（cm）')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.packageLength || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="packageWide" :label="$lang('宽（cm）')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.packageWide || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="packageNumber" :label="$lang('高（cm）')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.packageHigh || '--' }}</div>
          </template>
        </el-table-column> -->
        <!-- 快递类型 -->
        <el-table-column prop="expressTypeName" :label="$lang('快递类型')" min-width="80">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.expressTypeName}">{{ row.expressTypeName || '--' }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="paymentModeName" :label="$lang('结算方式')" min-width="80">
          <template slot-scope="{ row }">
            <div :class="{'errorData': !row.paymentModeName}">{{ row.paymentModeName || '--' }}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="paidModeName" :label="$lang('支付方式')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.paidModeName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="codCurrencyTypeName" :label="$lang('代收货款币别')" min-width="100">
          <template slot-scope="{ row }">
            <div>{{ row.codCurrencyTypeName || '--' }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="platformName" :label="$lang('平台')" min-width="80">
          <template slot-scope="{ row }">
            <div >{{ row.platformName || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="customerAccount" :label="$lang('客户账号')" min-width="80">
          <template slot-scope="{ row }">
            <div>{{ row.customerAccount || '--' }}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="codMoney" :label="$lang('代收货款金额')" min-width="100">
          <template slot-scope="{ row }">
            <div :class="{'errorData': row.errCodMoney }">{{ row.errCodMoney ? $lang('DR单不能填写COD') : row.codMoney }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="fodMoney" :label="$lang('到付运费金额')" min-width="100">
          <template slot-scope="{ row }">
            <div :class="{'errorData': row.checkResult && row.checkResult['fodMoney'] }">{{ row.checkResult && row.checkResult['fodMoney'] ? row.checkResult && row.checkResult['fodMoney'] : row.fodMoney || '--' }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="signReceipt" :label="$lang('是否签回单')" min-width="100">
          <template slot-scope="{ row }">
            <div>{{ row.signReceipt == null ? '--' : row.signReceipt === 0 ? $lang('否') : $lang('是') }}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="customerPickInfo" :label="$lang('客户拣货信息')" :show-overflow-tooltip="true" width="100">
          <template slot-scope="{ row }">
            <div>{{ row.customerPickInfo || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" :label="$lang('备注')" :show-overflow-tooltip="true" width="100">
          <template slot-scope="{ row }">
            <div>{{ row.remarks || '--' }}</div>
          </template>
        </el-table-column>

        <!-- 暂无数据提醒 -->
        <template slot="empty">
          <div class="avue-crud__empty">
            <slot name="empty" v-if="$slots.empty"></slot>
            <empty v-else size="50" :desc="$lang('暂无数据')"></empty>
          </div>
        </template>
      </el-table>
    </div>
    <AddressBook v-model="addrBook" :selectType="1" @single-row-select="singleRowSelect" ref="address"></AddressBook>
    <edit-order ref="editOrder" :orderData="rowData" v-model="editDialogVisible" @editSave="editSave" @editClose="editClose" :comeFrom="comeFromType"></edit-order>
    <BatchEdit v-if="batchEdit" v-model="batchEdit" @update="updateBatchOrder"></BatchEdit>
    <BatchUpload v-model="upload" :orderTemplate="excelImport" @success="uploadSuccess"></BatchUpload>
    <check-order @sureOrder="sureOrder" :repeatOrder="repeatOrder" :repeatVisible="checkOrderVisible" @checkOrderClose="checkOrderClose"></check-order>

    <el-dialog
      :title="$lang(OrderTemplate === 1 ? $lang('下载模板') : $lang('导入模板'))"
      :visible="OrderTemplate !== 0"
      @close="closeTemplate"
      width="900px"
      custom-class="downTemp"
      top="0"
    >
      <div class="dialog-line">
        <div class="dialog-down">
          <el-button type="primary" @click="downloadTemplate(5)">{{ $lang('下载模板1') }}</el-button>
          <span style="margin-left: 15px">{{ $lang('标准模板（无寄件人，带运单号）') }}</span>
        </div>
        <div class="dialog-down">
          <el-button type="primary" @click="downloadTemplate(6)">{{ $lang('下载模板2') }}</el-button>
          <span style="margin-left: 15px">{{ $lang('标准模板（含寄件人，带运单号）') }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import EditOrder from './components/EditOrder'
import BatchEdit from './BatchEdit'
import BatchUpload from './BatchUpload'
import AddressBook from '../single-order/AddressBook'
import { mapGetters } from 'vuex'
import elTableInfiniteScroll from './table-infinite-scroll'
import { RESPONSE_SUCCESS } from '@constants'
import { downloadTemplateNew, getDefaultAddress, threewayBatchSave, checkArea, getcomCostBatch } from '@api/module/customer'
import CheckOrder from './components/CheckOrder'
import empty from '@/components/jms-widget/jms-table-scroll/empty'

export default {
  name: 'BatchOrder',
  components: {
    EditOrder,
    BatchEdit,
    BatchUpload,
    AddressBook,
    CheckOrder,
    empty,
  },
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll,
  },
  data() {
    return {
      tabActive: 0,
      showAddress: true,
      isShowFirst: false,
      keyBtn: false,
      editDialogVisible: false,
      rowData: {},
      batchEdit: false,
      isRowDetailUrl: false,
      upload: false,
      showErr: false,
      showImportResult: false,
      disableSetOrder: true,
      comeFromType: 'order',
      userInfo: '',
      userSender: '',
      addrBook: false,
      list: [],
      options: [],
      multipleSelection: [],
      allLength: 0,
      successLength: 0,
      errorLength: 0,
      leadAllLength: 0, // 导入全部
      leadSuccessLength: 0, // 导入成功
      leadErrorLength: 0, // 导入失败
      initSenderAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      initReceiverAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      originList: [], // 数据源
      originArr: [], // 数据进行分组
      current: 0, // 分页数
      size: 50, // 数量
      isFirstCome: true,
      isSelectAll: false, // 是否全选
      failOrightList: [], // 失败
      successOrightList: [], // 成功
      selectedRow: [], // 单个选中的情况选中的行
      repeatOrder: '', // 重复订单
      checkOrderVisible: false, // 重复订单弹窗
      submitParams: {}, // 下单提交元素
      progress: 0, // 进度
      bulkOrdering: false, // 下单进度条是否显示
      showBulkResult: false, // 下单状态
      OrderTemplate: 0, // 模板弹窗,1为下载,2为导入
      excelImport: 0, // 导入模板
      containSender: false, // 含寄件人的模板
    }
  },
  activated() {
    if (!this.isFirstCome) {
      this.getDefaultAddress()
    }
  },
  computed: {
    ...mapGetters({
      tableHeight: 'tableHeight',
    }),
  },
  created() {
    this.userInfo = false
  },
  mounted() {
    this.getDefaultAddress()
    this.isFirstCome = false
  },
  watch: {},
  methods: {
    // 关闭模板弹窗
    closeTemplate() {
      this.OrderTemplate = 0
    },
    getRowKeys(row) {
      return row.formIndex
    },
    changeTab(index) {
      this.tabActive = index
      if (index === 0) {
        this.originList = this.successOrightList
      } else {
        this.originList = this.failOrightList
      }
      this.isSelectAll = false
      this.multipleSelection = []
      this.pageChange()
    },
    closeAlert() {
      this.showBulkResult = false
      this.showImportResult = false
    },
    tpyeformat(item, labelKey, valueKey) {
      return `${item.name}/${item.mobile}/${item.provinceName}/${item.cityName}/${item.areaName}`
    },
    load() {
      if (this.current >= this.originArr.length - 1 || this.list.length > 1000) return
      this.current++
      const second = this.originArr[this.current]
      this.list.push(...second)
      if (this.isSelectAll) {
        this.toggleSelection(second)
      }
    },
    // 打开地址
    open(selectType) {
      this.addrBook = true
      this.$refs.address.updateBtnStauts(this.userInfo)
    },
    singleRowSelect(data, type) {
      // console.log('data', data)
      this.userInfo = data
      data.provinceName = this.newStr(data.provinceName)
      data.cityName = this.newStr(data.cityName)
      data.areaName = this.newStr(data.areaName)
      this.userSender = `${data.name}/${data.mobile}/${data.provinceName}${data.cityName}${data.areaName}${data.street}${data.buildingNo}${data.buildingFloor}${data.roomNumber}`
    },
    // 重新选中复选框
    toggleSelection(rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true)
        })
      })
    },
    uploadSuccess(data, type) {
      // 判断导入模板是否包含寄件人信息
      this.containSender = !!(type && (type === 2 || type === 4))
      this.comeFromType = this.containSender ? 'order' : 'waybill'
      this.showImportResult = true
      this.showBulkResult = false
      this.upload = false
      this.OrderTemplate = 0
      const successList = data.data.successData || []
      const failList = data.data.failData || []
      failList.forEach((v, k) => {
        // DR单报错提示
        if (v.expressTypeCode === 'DR' && v.codMoney >= 0) {
          v.errCodMoney = true
        } else {
          v.errCodMoney = false
        }
      })
      this.successOrightList = successList
      this.failOrightList = failList
      this.leadAllLength = successList.length + failList.length
      this.leadErrorLength = failList.length
      this.leadSuccessLength = successList.length
      if (this.failOrightList.length > 0) {
        this.tabActive = 1
        this.originList = failList
      } else {
        this.tabActive = 0
        this.originList = successList
      }
      this.multipleSelection = []
      this.isSelectAll = false
      this.pageChange()
    },
    // 分割数据
    pageChange() {
      this.originArr = this.splitArray(this.originList)
      this.list = this.originArr[0]
      this.current = 0
      this.disableSetOrder = true
    },
    splitArray(arr) {
      const a_len = arr.length
      const result = []
      for (let i = 0; i < a_len; i += this.size) {
        result.push(arr.slice(i, i + this.size))
      }
      return result
    },
    // 编辑
    rowEdit(row, column, event) {
      // 回显数据
      this.rowData = Object.assign({}, { ...row })
      this.$nextTick(() => {
        this.editDialogVisible = true
      })
      console.log(this.rowData)
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      const obj = {}
      obj.senderProvinceId = this.userInfo.provinceId || ''
      obj.senderProvinceName = this.userInfo.provinceName || ''
      obj.senderCityId = this.userInfo.cityId || ''
      obj.senderCityName = this.userInfo.cityName || ''
      obj.senderAreaId = this.userInfo.areaId || ''
      obj.senderAreaName = this.userInfo.areaName || ''
      obj.senderName = this.userInfo.name
      obj.senderMobilePhone = this.userInfo.detailedAddress
      obj.senderDetailedAddress = this.userInfo.mobile
      return Object.assign({}, { ...row }, { ...obj })
    },
    // 批量导入
    importOrder() {
      // debugger
      this.upload = true
      // if (this.userInfo) {
      //   this.checkArea(this.userInfo)
      // } else {
      //   this.$message.warning(this.$lang('请选择寄件人信息'))
      //   return
      // }
    },
    // 检查省市区地址
    async checkArea(obj) {
      try {
        const { provinceId, cityId, areaId } = obj
        const { code, data } = await checkArea({ provinceId, cityId, areaId })
        if (code === 1 && data) {
          // this.upload = true
        } else {
          const msg = '该寄件地址尚未开放，敬请期待'
          this.$message.warning(this.$lang(msg))
        }
      } catch (error) {
        // this.upload = false
        this.$message.warning(this.$lang('请求异常'))
      }
    },
    batcheditOrder() {
      this.batchEdit = true
    },
    async downloadTemplate(type) {
      // 后端接口要求用formdata
      const params = { type }
      const formData = new FormData()
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key])
      })
      const res = await downloadTemplateNew(formData)
      if (res) {
        const enc = new TextDecoder('utf-8')
        let errorData = { code: null }
        try {
          errorData = JSON.parse(enc.decode(new Uint8Array(res))) // 转化成json对象
        } catch (error) {
          // errorData.code = null
        }
        if (errorData.code) {
          this.$message.error(errorData.msg)
        } else {
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            // IE
            const name = this.$lang('下载模板')
            window.navigator.msSaveOrOpenBlob(res, `${name}${type}.xls`)
          } else {
            // 火狐谷歌都兼容
            const url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' }))
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = url
            const name = this.$lang('下载模板')
            elink.setAttribute('download', `${name}${type}.xls`)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          }
        }
      }
    },
    // 删除订单
    deleteOrder() {
      const formIndexArray = []
      const originArray = []
      // 构建选中的订单formIndex数组
      this.multipleSelection.forEach((item) => {
        formIndexArray.push(item.formIndex)
      })
      this.originList.forEach((originListItem) => {
        if (formIndexArray.indexOf(originListItem.formIndex) < 0) {
          originArray.push(originListItem)
        }
      })
      this.multipleSelection = []
      if (this.tabActive === 0) {
        this.successOrightList = originArray
      } else {
        this.failOrightList = originArray
      }
      this.originList = originArray
      this.isSelectAll = false
      // 重新分页赋值
      this.pageChange()
    },
    // 获取默认地址
    async getDefaultAddress() {
      const param = {
        type: 1,
      }
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        this.$nextTick(() => {
          if (data) {
            this.userInfo = data || ''
            data.provinceName = this.newStr(data.provinceName)
            data.cityName = this.newStr(data.cityName)
            data.areaName = this.newStr(data.areaName)
            this.userSender = `${data.name}/${data.mobile}/${data.provinceName}${data.cityName}${data.areaName}${data.street}${data.buildingNo}${data.buildingFloor}${data.roomNumber}`
          }
        })
      } else {
        this.$message.error(msg)
      }
    },
    // 全选
    handleSelectAll(val) {
      if (val.length > 0) {
        this.isSelectAll = true
        // this.disableSetOrder = false
        this.multipleSelection = this.originList
      } else {
        this.isSelectAll = false
        this.disableSetOrder = true
        this.multipleSelection = []
      }
      this.isSinleSelection = []
      this.checkSetOrder(this.multipleSelection)
    },
    // 单个选中
    handleSelectionChange(val, currentRow) {
      // debugger
      // console.log('currentRow', currentRow)
      // 检测当前行的选中状态
      const isChecked = val.some((item) => item.formIndex === currentRow.formIndex)
      if (this.isSelectAll) {
        if (!isChecked) {
          this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.formIndex]
        } else {
          this.isSinleSelection = this.isSinleSelection.filter((item) => item !== currentRow.formIndex)
        }
        this.multipleSelection = this.originList.filter((item) => !this.isSinleSelection.includes(item.formIndex))
      } else {
        this.multipleSelection = val
      }
      this.checkSetOrder(this.multipleSelection)
    },

    checkSetOrder(val, type) {
      // type:batchEdit(批量设置后)
      // 选中的订单只要有一个有错误字段未处理就不能下单
      if (this.tabActive === 1 && type === 'batchEdit') {
        this.deleteList = []
        if (val.length) {
          val.forEach((item) => {
            if (this.checkOrder(item)) {
              this.deleteList.push(item)
            }
          })
        }
        this.disableSetOrder = true
        if (this.deleteList.length > 0) {
          this.updateList()
        }
      } else {
        if (
          !val.length ||
          val.some((item) => {
            if (!this.checkOrder(item)) {
              return true
            }
          })
        ) {
          this.disableSetOrder = true
          return
        }
        this.disableSetOrder = false
      }
    },

    // 更新导入成功、导入失败数据
    updateList() {
      this.deleteList.forEach((deleteItem) => {
        const formIndex = deleteItem.formIndex
        this.originList.splice(
          this.originList.findIndex((item) => item.formIndex === formIndex),
          1
        )
        this.list.splice(
          this.list.findIndex((item) => item.formIndex === formIndex),
          1
        )
        this.failOrightList = this.originList
        if (this.successOrightList.length > 0) {
          let sIndex = 0
          if (
            this.successOrightList.some((item, index) => {
              sIndex = index
              if (item.formIndex > formIndex) {
                return true
              }
            })
          ) {
            if (sIndex <= 0) {
              this.successOrightList.unshift(deleteItem)
            } else {
              this.successOrightList.splice(sIndex, 0, deleteItem)
            }
          } else {
            sIndex = sIndex + 1
            this.successOrightList.splice(sIndex, 0, deleteItem)
          }
        } else {
          this.successOrightList.push(deleteItem)
        }
      })
      if (this.failOrightList.length > 0) {
        this.pageChange()
      }
      if (!this.failOrightList || this.failOrightList.length === 0) {
        this.changeTab(0)
        this.showImportResult = false
      }
      this.deleteList = []
      this.multipleSelection = []
    },

    // checkOrder(data) {
    //   const {
    //     receiverName,
    //     receiverMobilePhone,
    //     receiverProvinceName,
    //     receiverCityName,
    //     receiverAreaName,
    //     receiverDetailedAddress,
    //     goodsTypeName,
    //     packageTotalWeight,
    //     packageNumber,
    //     paymentModeName,
    //   } = data
    //   if (
    //     !receiverName ||
    //     !receiverMobilePhone ||
    //     !receiverProvinceName ||
    //     !receiverCityName ||
    //     !receiverAreaName ||
    //     !receiverDetailedAddress ||
    //     !goodsTypeName ||
    //     !packageTotalWeight ||
    //     !packageNumber ||
    //     !paymentModeName
    //   ) {
    //     return false
    //   }
    //   return true
    // },
    checkOrder(data) {
      const {
        receiverName,
        receiverMobilePhone,
        receiverProvinceName,
        receiverCityName,
        receiverAreaName,
        receiverDetailedAddress,
        goodsTypeName,
        packageTotalWeight,
        // packageNumber,
        // paymentModeName,

        senderName,
        senderMobilePhone,
        senderDetailedAddress,
        senderProvinceId,
        senderCityName,
        senderAreaName,
      } = data
      if (this.containSender) {
        console.log('包含寄件人')
        // 包含寄件人
        if (
          !receiverName ||
          !receiverMobilePhone ||
          !receiverProvinceName ||
          !receiverCityName ||
          !receiverAreaName ||
          !receiverDetailedAddress ||
          !goodsTypeName ||
          !packageTotalWeight ||
          // !packageNumber ||
          // !paymentModeName ||
          !senderName ||
          !senderMobilePhone ||
          !senderDetailedAddress ||
          !senderProvinceId ||
          !senderCityName ||
          !senderAreaName
        ) {
          return false
        }
      } else {
        // 不含寄件人
        console.log('不含寄件人')
        if (
          !receiverName ||
          !receiverMobilePhone ||
          !receiverProvinceName ||
          !receiverCityName ||
          !receiverAreaName ||
          !receiverDetailedAddress ||
          !goodsTypeName ||
          !packageTotalWeight
        ) {
          return false
        }
      }

      return true
    },
    // 字符串截取
    newStr(str) {
      if (str != null && str.indexOf('（') > -1) {
        return str.substring(0, str.indexOf('（'))
      } else {
        return str
      }
    },
    editSave(data) {
      console.log(data, '____________')
      if (data.payment) {
        const paymentkey = Object.keys(data.payment).some((item) => {
          return data.payment[item] === null
        })
        if (paymentkey) {
          data.payment = null
        }
      }
      if (data.goods) {
        const goodskey = Object.keys(data.goods).some((item) => {
          return data.goods[item] === null
        })
        if (goodskey) {
          data.goods = null
        }
      }
      console.log('data', { ...data })
      this.$refs['editOrder'].$refs['orderForm'].validate(async (valid) => {
        if (valid) {
          const formData = {
            id: data.id, // 订单编号,
            formIndex: data.formIndex, //
            receiverName: data.receiverName, // 收件人姓名,
            receiverMobilePhone: data.receiverMobilePhone, // 收件人手机号,
            receiverTelphone: data.receiverTelphone, // 收件人手机号2,
            receiverProvinceId: data.receiverProvinceId, // 收件省份id,
            receiverProvinceName: data.receiverProvinceName, // 收件省份名称,
            receiverCityId: data.receiverCityId, // 收件城市id,
            receiverCityName: data.receiverCityName, // 收件城市名称,
            receiverAreaId: data.receiverAreaId, // 收件区域id,
            receiverStreet: data.receiverStreet, // 收件街道名称,
            receiverAreaName: data.receiverAreaName, // 收件区域名称
            receiverBuildingNo: data.receiverBuildingNo, // 收件楼号
            receiverFloor: data.receiverFloor, // 收件楼层
            receiverRoomNumber: data.receiverRoomNumber, // 收件楼层
            receiverRemark: data.receiverRemark, // 收件备注
            customerCode: data.customerCode, // 客户code,
            senderName: data.senderName, // 寄件人姓名,
            senderMobilePhone: data.senderMobilePhone, // 寄件人手机号,
            senderTelphone: data.senderTelphone, // 寄件人手机号2,
            senderProvinceId: data.senderProvinceId, // 寄件省份id,
            senderProvinceName: data.senderProvinceName, // 寄件省份名称,
            senderCityId: data.senderCityId, // 寄件城市id,
            senderCityName: data.senderCityName, // 寄件城市名称,
            senderAreaName: data.senderAreaName, // 寄件地区
            senderAreaId: data.senderAreaId, // 寄件地区
            sendBuildingNo: data.sendBuildingNo, // 寄件楼号
            sendFloor: data.sendFloor, // 寄件楼层
            sendRoomNumber: data.sendRoomNumber, // 寄件房号
            sendRemark: data.sendRemark, // 寄件备注
            // paymentModeCode: data.paymentModeCode, // 结算方式code（支付方式）,
            // paymentModeId: data.paymentModeId,
            // paymentModeName: data.paymentModeName,
            expressTypeCode: data.expressTypeCode, // 快递类型code
            expressTypeName: data.expressTypeName, // 快递类型name
            senderDetailedAddress: data.senderDetailedAddress, // 寄件详细地址,
            // senderAreaId: data.senderAreaId, // 寄件区域Id,
            declaredValue: data.declaredValue, // 保价金额,
            receiverDetailedAddress: data.receiverDetailedAddress, // 收件详细地址,
            receiverCompany: data.receiverCompany, // 收件公司名称
            goodsTypeId: data.goods.id, // 物品类型code,
            goodsTypeName: data.goods.name, // 物品类型code,
            goodsTypeCode: data.goods.code, // 物品类型code,
            paidModeCode: data.paidMode.code, // 支付方式code
            paidModeId: data.paidMode.id, // 支付方式id
            paidModeName: data.paidMode.name, // 支付方式name

            insured: data.insured, // 是否保价1是，0否
            insuredValue: data.insuredValue, // 保价费,
            standardValue: data.standardValue, // 标准运费,
            senderStreet: data.senderStreet, // 寄件区域名称,
            customerId: data.customerId, // 客户id(会员id),
            customerName: data.customerName, // 客户名称,
            packageTotalWeight: 1, // 物品重量,
            packageNumber: data.packageNumber, // 物品件数,
            goodsName: data.goodsName, // 物品名称,
            packageLength: data.packageLength, // 物品长,
            packageWide: data.packageWide, // 物品宽,
            packageHigh: data.packageHigh, // 物品高,
            codMoney: data.codMoney, // 代收货款金额,
            codCurrencyTypeName: data.codCurrencyTypeName, // 代收货款币别
            codCurrencyTypeCode: data.codCurrencyTypeCode, // 代收货款币别code
            customerAccount: data.customerAccount,
            platformName: data.platformName, // 平台名称
            receiverEmail: data.receiverEmail, // 邮箱
            receiverPostalCode: data.receiverPostalCode, // 邮编
            // customerAccount: data.customerAccount,
            // customerAccount: data.customerAccount,
            // customerAccount: data.customerAccount,
            // customerAccount: data.customerAccount,
            boxStandardId: data.boxStandardId, // 箱子规格id,
            boxStandardCode: data.boxStandardCode, // 箱子规格code,
            boxStandardName: data.boxStandardName, // 箱子规格名称,
            boxNumber: data.boxNumber, // 箱子数量,
            boxPrice: data.boxPrice, // 箱子单价,
            remarks: data.remarks, // 备注,
            receivableFreight: data.receivableFreight, // 参考运费,
            from: 8, // 8 来源 大客户,
            settlementWeight: data.settlementWeight, // 结算重量
            packageChargeWeight: 1, // 结算重量
            customerOrderId: data.customerOrderId,
            langType: data.langType,
            customerPickInfo: data.customerPickInfo,
            customerPickNumber: data.customerPickNumber,
            waybillId: data.waybillId,
            thirdPartyWaybillId: data.thirdPartyWaybillId,
            fodMoney: data.fodMoney || '',
          }
          // 编辑保存
          // this.submitForm('reqUpdate', formData)
          var formParams = Object.assign({}, formData)
          formParams.senderProvinceName = this.newStr(formParams.senderProvinceName)
          formParams.senderCityName = this.newStr(formParams.senderCityName)
          formParams.senderAreaName = this.newStr(formParams.senderAreaName)
          formParams.receiverProvinceName = this.newStr(formParams.receiverProvinceName)
          formParams.receiverCityName = this.newStr(formParams.receiverCityName)
          formParams.receiverAreaName = this.newStr(formParams.receiverAreaName)
          this.updateSingleOrder(formParams)
          console.log(formParams)
        } else {
          return false
        }
      })
    },

    editClose() {
      this.keyBtn = false
      this.editDialogVisible = false
    },
    async setOrder() {
      // debugger
      this.keyBtn = true
      if (this.multipleSelection.length === 0) return this.$message.warning(this.$lang('请选择要下单的订单'))
      // 选中多个订单，修改寄件人信息和更新保价费
      if (this.containSender) {
        console.log('包含寄件人')
        this.multipleSelection.forEach((item, index) => {
          //   item.insuredValue = item.insuredValue || 0 // 默认使用0  后台会重新计算
          item.packageChargeWeight = 1
          //   item.packageNumber = 1
        })
      } else {
        if (this.userInfo) {
          this.checkArea(this.userInfo)
        } else {
          this.$message.warning(this.$lang('请选择寄件人信息'))
          this.keyBtn = false
          return
        }
        console.log('不包含寄件人')
        this.multipleSelection.forEach((item, index) => {
          console.log('this.userInfo', this.userInfo)
          //   item.insuredValue = item.insuredValue || 0 // 默认使用0  后台会重新计算
          item.senderDetailedAddress = this.userInfo.detailedAddress
          item.senderProvinceId = this.userInfo.provinceId
          item.senderProvinceName = this.userInfo.provinceName
          item.senderCityId = this.userInfo.cityId
          item.senderCityName = this.userInfo.cityName
          item.senderAreaId = this.userInfo.areaId
          item.senderAreaName = this.userInfo.areaName
          item.senderStreet = this.userInfo.street
          item.senderName = this.userInfo.name
          item.sendBuildingNo = this.userInfo.buildingNo
          item.sendFloor = this.userInfo.buildingFloor
          item.sendRoomNumber = this.userInfo.roomNumber
          item.senderMobilePhone = this.userInfo.mobile
          item.packageChargeWeight = 1 // 重量默认传1
          //   item.packageNumber = 1
        })
      }

      this.submitParams = {
        orders: this.multipleSelection,
      }
      this.bulkOrder()
    },
    // 判断是否有重复单弹窗
    checkOrderClose() {
      this.checkOrderVisible = false
    },
    // 有重复单继续下单
    sureOrder() {
      this.checkOrderClose()
      this.bulkOrder()
    },
    // 批量下单
    async bulkOrder() {
      this.keyBtn = true
      this.showImportResult = false
      this.showBulkResult = false
      this.bulkOrdering = true
      this.progress = 0
      const timer1 = setInterval(() => {
        this.progress++
        if (this.progress >= 98) {
          clearInterval(timer1)
        }
      }, 20)
      const result = await threewayBatchSave(this.submitParams)
      clearInterval(timer1)
      const timer2 = setInterval(() => {
        this.progress++
        if (this.progress >= 100) {
          clearInterval(timer2)
          submitSuccess()
        }
      }, 20)
      const $this = this
      const submitSuccess = function () {
        const { code, msg, data } = result
        if (code === RESPONSE_SUCCESS) {
          $this.bulkOrdering = false
          $this.allLength = $this.submitParams.orders.length || 0
          $this.errorLength = data.length || 0
          $this.successLength = $this.allLength - $this.errorLength
          $this.showBulkResult = true

          if (data.length === 0) {
            $this.showErr = false
            // 全部下单成功
            $this.$message.success($this.$lang('下单成功'))
            $this.deleteOrder()
          } else if (data.length > 0) {
            $this.showErr = true
            // 没下单成功的
            // 1.先删除下单的数据
            const formIndexArray = []
            const originArray = []
            $this.multipleSelection.forEach((item) => {
              formIndexArray.push(item.formIndex)
            })
            $this.originList.forEach((originListItem) => {
              if (formIndexArray.indexOf(originListItem.formIndex) < 0) {
                originArray.push(originListItem)
              }
            })
            // 2.在添加失败的数据
            data.forEach((item) => {
              originArray.unshift(item)
            })
            // 3.调整顺序
            originArray.sort((a, b) => {
              return a.formIndex - b.formIndex
            })

            $this.multipleSelection = []
            if ($this.tabActive === 0) {
              $this.successOrightList = originArray
            } else {
              $this.failOrightList = originArray
            }
            $this.originList = originArray
            $this.isSelectAll = false
            // 重新分页赋值
            $this.pageChange()
          }
          $this.disableSetOrder = true
        } else {
          $this.bulkOrdering = false
          $this.disableSetOrder = false
          $this.$message.error(msg)
        }
        $this.keyBtn = false
      }
    },
    // 更新订单表格的数据
    updateOrder(formData) {
      this.$nextTick(() => {
        this.list &&
        this.list.some((item, index) => {
          if (item.formIndex === formData.formIndex) {
            this.$set(this.list, index, formData)
            this.editClose()
          }
        })
        this.originList &&
        this.originList.some((itemOrigin, index) => {
          if (itemOrigin.formIndex === formData.formIndex) {
            this.$set(this.originList, index, formData)
          }
        })
      })
    },
    // 单个编辑更新数据
    updateSingleOrder(formData) {
      // 被修改字段的数组
      const settingArray = []
      for (const key in formData) {
        settingArray.push(key)
      }
      const selectCur = this.multipleSelection.filter((item) => item.formIndex === formData.formIndex)
      if (selectCur.length) {
        // 如果有选中复选框
        this.updateSingleData(this.list, settingArray, 'list', formData)
        this.updateSingleData(this.originList, settingArray, 'originList', formData)
      } else {
        // 没有选中复选框
        this.updateOrder(formData)
      }
      this.editClose()
      if (this.tabActive === 1) {
        this.checkSetOrder([formData], 'batchEdit')
      } else {
        this.checkSetOrder(this.multipleSelection)
      }
    },
    // 单条更新数据
    updateSingleData(list, settingArray, listName, formData) {
      list.forEach((item, index) => {
        if (item.formIndex === formData.formIndex) {
          settingArray.forEach((element) => {
            this.$set(this[listName][index], element, formData[element])
          })
        }
      })
    },

    // 批量改保价费
    async batchUpdateFee(arr) {
      try {
        const { code, msg, data } = await getcomCostBatch(arr)
        if (code === RESPONSE_SUCCESS && data) {
          this.feeObj = data
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        this.$message.warning(this.$lang('请求异常'))
      }
    },
    // 批量设置后更新表格数据
    async updateBatchOrder(data, from) {
      // 被修改字段的数组
      const settingArray = []
      for (const item in data.editState) {
        if (data.editState[item].checked) {
          settingArray.push(data.editState[item].key)
        }
      }
      this.batchEdit = false
      const checkArray = []
      const arr = []
      this.feeObj = {} // 保价费集合
      this.multipleSelection.forEach((element) => {
        checkArray.push(element.formIndex)
        const { code } = data.formData.goods
        const goodsTypeCode = code || element.goodsTypeCode
        const declaredValue = data.formData.declaredValue || element.declaredValue
        if (goodsTypeCode && declaredValue) {
          arr.push({
            mapKey: element.formIndex,
            value: declaredValue,
            goodsTypeCode: goodsTypeCode,
          })
        }
      })
      if ((settingArray.indexOf('goods') > -1 || settingArray.indexOf('declaredValue') > -1) && arr.length) {
        await this.batchUpdateFee(arr)
      }
      this.updateData(this.list, checkArray, settingArray, 'list', data.formData)
      this.updateData(this.originList, checkArray, settingArray, 'originList', data.formData)
      this.checkSetOrder(this.multipleSelection, 'batchEdit')
    },
    // 批量设置更新数据
    updateData(list, checkArray, settingArray, listName, formData) {
      list.forEach((item, index) => {
        if (checkArray.indexOf(item.formIndex) > -1) {
          const fee = (this.feeObj && this.feeObj[item.formIndex]) || ''
          settingArray.forEach((element) => {
            // 物品类型
            if (element === 'goods') {
              const { id, code, name } = formData.goods
              this.$set(this[listName][index], 'goodsTypeId', id)
              this.$set(this[listName][index], 'goodsTypeCode', code)
              this.$set(this[listName][index], 'goodsTypeName', name)
              this.$set(this[listName][index], 'insuredValue', fee)
            } else if (element === 'payment') {
              const { id } = formData.payment
              // this.$set(this[listName][index], 'paymentModeId', id)
              // this.$set(this[listName][index], 'paymentModeCode', code)
              // this.$set(this[listName][index], 'paymentModeName', name)
              if (id === 321) {
                this.$set(this[listName][index], 'declaredValue', '')
                this.$set(this[listName][index], 'insuredValue', '')
              }
            } else if (element === 'boxStandard') {
              const { id, name, salesPrice } = formData.boxStandard
              this.$set(this[listName][index], 'boxStandardId', id)
              this.$set(this[listName][index], 'boxStandardName', name)
              this.$set(this[listName][index], 'boxPrice', salesPrice)
            } else if (element === 'declaredValue') {
              this.$set(this[listName][index], 'insuredValue', fee)
            }
            this.$set(this[listName][index], element, formData[element])
          })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.batch-order {
  position: relative;

  .search-group {
    display: flex;

    .search {
      flex: 1;
      padding: 20px 24px;

      .buttons {
        margin-bottom: 10px;
      }
    }

    .setOrder {
      align-self: center;
      margin-right: 50px;
    }
  }

  .list {
    padding: 16px 24px;
    background: #edeef3;
    flex: 1;
  }

  .tooltip-click {
    background-color: $--color-primary;
    cursor: pointer;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    -webkit-text-fill-color: #fff;
    margin-left: 5px;
  }
}

.errorData {
  background: rgba(245, 34, 45, 0.5);
  height: 25px;
  cursor: pointer;
  text-align: center;
  color: #fff;
}

.place-order {
  text-align: center;
  margin-top: 8px;
}

.tabs {
  height: 39px;

  div {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 12px 20px;
    font-size: 14px;
    background: #e0e1e7;
    height: 40px;
    border: 0;
    background: #e0e1e7;
    border-radius: 8px 8px 0 0;
    color: #666;

    i {
      margin-right: 8px;
      color: #666;
    }

    &.active {
      background: #fff;
      color: #e60012;

      i {
        color: #e60012;
      }
    }
  }
}
.errorData {
  background: rgba(245, 34, 45, 0.5);
  height: 25px;
  cursor: pointer;
  text-align: center;
  color: #fff;
}
.progress-box {
  width: 100%;
  height: 30px;
  line-height: 28px;
  text-align: center;
  background-color: #eef9e8;
  display: flex;
  justify-content: center;
  align-items: center;

  .progress-container {
    justify-content: space-between;
    display: flex;
    align-items: center;
    width: 490px;

    .progress-wrap {
      width: 400px;
      height: 6px;
      background: #e7ebf4;
      border-radius: 6px;
      display: inline-block;
    }

    .progress {
      background: #52c41a;
      border-radius: 6px;
      width: 0;
      height: 100%;
    }

    .num {
      color: #666;
      font-size: 12px;
      display: inline-block;
    }
  }
}

.errorTip {
  overflow: hidden;
  color: red;
}
</style>
<style lang="scss">
.el-table .cell.el-tooltip {
  > div {
    overflow: hidden;
  }
}

.downTemp {
  .el-dialog__body {
    padding: 20px !important;
  }

  .dialog-line {
    display: flex;
    margin-top: 15px;
    height: 50px;

    .dialog-down {
      flex: 1;
    }
  }
}

.batch-order {
  .el-table__fixed-body-wrapper {
    top: 41px !important;
  }
}
</style>
